export default {"src":"/_next/static/media/pregnancy-test.8e8d6198.svg","height":361,"width":1154};